/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { styled } from 'fierry/react';

import BoardUser from 'solis/claude/logic/board/user';


const getControl = ({ zoneTimeline, user, currentDate }) =>
{
  return zoneTimeline.getControl(user, currentDate);
};


const getColor = ({ zoneTimeline, user, currentDate }) =>
{
  return new BoardUser(zoneTimeline.getZone(currentDate).getBoard(), user).getColor();
};


const Track = styled.div`
  display: flex;
  overflow: hidden;

  gap: 1px;
  height: 6px;
  border-radius: 3px;
`;


const Segment = styled.span`
  flex-basis: 0;
  flex-grow: ${props => getControl(props)};

  background-color: ${props => `var(--${getColor(props)}-11)`};
`;


const Segments = ({ zoneTimeline, currentDate }) =>
{
  const sortCallback = (lhs, rhs) =>
  {
    return zoneTimeline.getControl(lhs, currentDate) - zoneTimeline.getControl(rhs, currentDate);
  };

  return zoneTimeline.getControlUsers(currentDate).sort(sortCallback).map(user =>
  (
    <Segment key = {user} zoneTimeline = {zoneTimeline} user = {user} currentDate = {currentDate} />
  ));
};


export default ({ zoneTimeline, currentDate }) =>
(
  <Track>
    <Segments zoneTimeline = {zoneTimeline} currentDate = {currentDate} />
  </Track>
);
